<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>票据管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form
      :inline="true"
      :model="formInline"
      label-position="right"
      label-width="120px"
      class="searchBar"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="票号" prop="moneyOrderCode">
            <el-input
              size="small"
              clearable
              v-model="formInline.moneyOrderCode"
              placeholder="票号"
            ></el-input>
          </el-form-item>
        </el-col>
         <el-col :span="8">
          <el-form-item label="背书户" prop="customerName">
            <el-input
              size="small"
              clearable
              v-model="formInline.customerName"
              placeholder="背书户"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="承兑人">
            <el-input
                size="small"
                clearable
                v-model="formInline.acceptorName"
                placeholder="承兑人"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <el-form-item>
                <el-upload
                class="upload-demo"
                action="#"
                :show-file-list = "false"
                :http-request="handleFileUpload"
                multiple
                >
                <el-button size="small" type="success">PDF上传</el-button>
              </el-upload>
              </el-form-item>
              </el-col>
        <el-col :span="10">
            <el-button
              style="margin-left: 10px "
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="info"
              icon="el-icon-delete"
              @click="handleReset"
              >清空</el-button
            >
            <el-button size="small" icon="el-icon-refresh" @click="getData"
              >刷新</el-button
            >
            <el-button
              size="small"
              icon="el-icon-s-claim"
              @click="handleBatchStoreTicket"
              >批量入库</el-button
            >
            <el-button
              size="small"
              icon="el-icon-delete-solid"
              @click="handleBatchDeleteTicket"
              >批量删除</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
      :cell-style="handleCellStyle"
      @select="handleSelect"
      @select-all="handleSelect"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-image
                :src="props.row.obverseURL"
                :preview-src-list="[props.row.obverseURL]"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <el-image
                :src="props.row.reverseURL"
                :preview-src-list="[props.row.reverseURL]"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-col>
            <el-col :span="16">
              <el-form label-position="right" label-width="120px" size="small">
                <el-form-item label="背书户">
                  <span>{{ props.row.customerName }}</span>
                </el-form-item>
                <el-form-item label="剩余天数">
                  <span v-if="props.row.remainderDay < 0" style="color: red">
                    {{ props.row.remainderDay }}
                  </span>
                  <span v-else>{{ props.row.remainderDay }}</span>
                </el-form-item>
                <el-form-item label="到期日期" width="100px">
                  <span>{{ props.row.dueDate | handleFormatDate }}</span>
                </el-form-item>
                <el-form-item label="金额（万）">
                  <span>{{ props.row.faceValue }}</span>
                </el-form-item>
                <el-form-item label="有无瑕疵">
                  <span v-if="props.row.flaw" style="color: red">{{
                    props.row.flaw
                  }}</span>
                  <span v-else>无瑕疵</span>
                </el-form-item>
                <el-form-item label="票号">
                  <span>{{ props.row.moneyOrderCode }}</span>
                </el-form-item>
                <el-form-item label="状态">
                  <span>{{ props.row.status }}</span>
                </el-form-item>
                <el-form-item label="是否线上">
                  <el-checkbox
                    size="small"
                    :false-label="1"
                    :true-label="0"
                    v-model="props.row.isOutLine"
                    placeholder="是否线上"
                  ></el-checkbox>
                </el-form-item>
                <el-form-item label="数量">
                  <el-input-number
                    :min="0"
                    :step="1"
                    size="small"
                    :controls="false"
                    v-model="props.row.allCount"
                    disabled
                    placeholder="数量"
                  ></el-input-number>
                </el-form-item>
                <el-form-item>
                  <el-autocomplete
                    style="width: 220px"
                    size="small"
                    v-model="props.row.inSalesman"
                    :fetch-suggestions="querySearch"
                    placeholder="输入内容自动匹配业务员"
                    :trigger-on-focus="false"
                    @select="handleConfirmSelectSaleman($event, props.row)"
                  >
                    <template slot-scope="{ item }">
                      <div>
                        {{ item.realName + "（" + item.dept.deptName + "）" }}
                      </div>
                    </template>
                  </el-autocomplete>
                  <el-button
                    size="small"
                    type="primary"
                    icon="el-icon-s-promotion"
                    @click="handleStoreTicket(props.row)"
                    >入库</el-button
                  >
                  <el-button
                    size="small"
                    type="info"
                    icon="el-icon-delete"
                    @click="handleDeleteTicket(props.row)"
                    >取消</el-button
                  >
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column label="是否线上" prop="isOutLine" align="center" width="40">
        <template slot-scope="props">
          <!-- 0 线上 1 线下 -->
          <el-checkbox
              size="small"
              :false-label="1"
              :true-label="0"
              v-model="props.row.isOutLine"
              placeholder="是否线上"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="客户类型" align="center" prop="isOutLine" width="150px">
        <template slot-scope="props">
          <el-select v-model="props.row.cusType" placeholder="">
            <el-option
                v-for="item in customerType"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="所在户" align="center" prop="isOutLine" width="100px">
        <template slot-scope="props">
          <el-select v-model="props.row.account" placeholder="">
            <el-option
                v-for="item in addTableData"
                :key="item.value"
                :label="item.value"
                :value="item.key"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="数量" align="center"  prop="allCount" width="100">
        <template slot-scope="props">
          <el-input-number
              :min="0"
              :step="1"
              step-strictly
              :controls="false"
              size="small"
              v-model="props.row.allCount"
              placeholder="票据数量"
              style="width: 60px"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
          label="背书户"
          align="center"
          prop="customerName"
          width = "250"
      >
        <template slot-scope="props">
          <el-input
              type="textarea"
              rows="1"
              :autosize="{minRows:1,maxRows:1}"
              size="small"
              v-model="props.row.customerName"
              auto-complete="off"
              placeholder="背书户"
          ></el-input>


        </template>
      </el-table-column>




      <el-table-column label="票号" prop="moneyOrderCode" align="center" >
        <template slot-scope="props">
<!--          <el-tooltip-->
<!--            effect="dark"-->
<!--            :content="props.row.moneyOrderCode"-->
<!--            placement="top-start"-->
<!--          >-->
            <span
              ><span>{{ props.row.moneyOrderCode.slice(-9) }}</span></span
            >
<!--          </el-tooltip>-->
        </template>
      </el-table-column>
      <el-table-column label="承兑人" prop="acceptorName" width="140px" align="center" >
      </el-table-column>
      <el-table-column label="票面金额（万）" prop="faceValue" align="center" >
      </el-table-column>
      <el-table-column
        label="到期日"
        prop="dueDate"
        :formatter="handleFormatDate" align="center" width="100"
      >
      </el-table-column>
      <el-table-column label="瑕疵" prop="flaw" > </el-table-column>
      <el-table-column label="剩余天数" prop="remainderDay" align="center" > </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleStoreTicket(scope.row)"
            >入库</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :pager="pager" @pager="handlePager"></Pagination>
    <StoreDetail
      :editForm="editForm"
      :visible.sync="storeVisible"
      @confirm="handleStoreConfirm"
    ></StoreDetail>
    <EditPatch
      title="批量入库"
      :visible.sync="batchVisible"
      @confirm="handleBatchEditFormConfirm"
    ></EditPatch>
  </div>
</template>

<script>
import {
  unhandledTicket,
  delTicket,
  delBatchTicket,
  storeTickBySalesman,
  updateBatchCaptureTicket,
  uploadLoad
} from "@/api/ticket/ticket";
import { listSalesman } from "@/api/system/user";
import Pagination from "@/components/pagination";
import StoreDetail from "@/views/ticket/ticket-store/add-edit";
import { formatMoney, timestampToDate } from "@/utils";
import EditPatch from "./batch.vue";

export default {
  filters: {
    handleFormatMoney(val) {
      if (val) {
        return formatMoney(val);
      }

      return val;
    },
    handleFormatDate(val) {
      if (val) {
        return timestampToDate(val);
      }

      return val;
    },
  },
  computed: {
    isAuthoried() {
      return (
        this.$store.getters.getUserInfo.role.menus &&
        this.$store.getters.getUserInfo.role.menus.length > 0
      );
    },
  },
  watch: {
    $route: {
      handler: function () {
        if (!this.isAuthoried) {
          this.$router.push({
            path: "/noauth?message=无权访问",
            replace: true,
          });
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      loading: false,
      userData: [],
      editForm: {
        customerName: "",
      },
      storeVisible: false,
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
      formInline: {
        moneyOrderCode: "",
      },
      batchVisible: false,
      selectRows: [],
      addTableData:[
      {"key":"a","value":"    A"},
        {"key":"b","value":"    B"},
        {"key":"c","value":"    C"},
        {"key":"d","value":"    D"},
        {"key":"e","value":"    E"},
        {"key":"f","value":"    F"},
        {"key":"g","value":"    G"},
        {"key":"h","value":"    H"},
      ],
      customerType:[
        {"key":"C_1","value":"公司客户"},
        {"key":"C_2","value":"中介"},
        {"key":"C_3","value":"终端客户"},
      ]
    };
  },
  components: {
    Pagination,
    StoreDetail,
    EditPatch,
  },
  created() {
    this.getData();
  },
  methods: {
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }

      return cellValue;
    },
    handleFileUpload(file) {
      let formData = new FormData();
      formData.append("file", file.file);

      this.loading = true;
      uploadLoad(formData)
          .then(() => {
            this.getData();
          })
          .catch(this.$message.error)
          .finally(() => {
            this.loading = false;
          });


     },
    querySearch(name, call) {
      listSalesman(name)
        .then((list) => {
          call(list);
          if (list.length <= 0) {
            this.$message.warning("不存在该业务员");
          }
        })
        .catch(this.$message.error);
    },
    handleFormatMoney(row, column, cellValue) {
      if (cellValue) {
        return formatMoney(cellValue);
      }

      return cellValue;
    },
    handleCellStyle({ row, column }) {
      console.info(row.flawCompany)
      if (
        "flaw" === column.property ||
        ("remainderDay" === column.property && row.remainderDay < 0) ||
          row.moneyOrderCode.indexOf("-") > -1 || row.flawCompany
      ) {

        return {
          color: "red",
        };
      }
      return null;
    },
    handleConfirmSelectSaleman(data, originData) {
      if (data) {
        originData.inSalesman = data.realName;
        originData.inSalesmanId = data.id;
      }
    },
    handleStoreConfirm() {
      this.$message.success("操作成功");
      this.getData();
    },
    handleAdd() {
      this.editFormVisible = true;
    },
    handleStoreTicket(row) {
      this.editForm = row;

      if(!this.editForm.cusType){
        this.$message.warning("未选择客户类型，无法操作！");
        return;
      }
      if(row.account){
        this.loading = true;
        storeTickBySalesman(row)
          .then(() => {
            this.storeVisible = true;
          })
          .catch(this.$message.error)
          .finally(() => {
            this.loading = false;
          });
      }else{
        this.$message.warning("未选择所在户，无法操作！");
      }
      
    },
    handleBatchStoreTicket() {
      if(this.selectRows.length){
        this.batchVisible = true;
      }else{
        this.$message.error("未选中数据，无法操作！");
      }

    },
    handleDeleteTicket(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delTicket(row.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.getData();
            })
            .catch(() => {
              this.$message.error("数据删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },
    handleBatchDeleteTicket(rows) {
      if(this.selectRows.length){
        delBatchTicket(
            this.selectRows.map((item) => {
              return item.id;
            })
        ).then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.getData();
            })
            .catch(() => {
              this.$message.error("数据删除失败，请稍后再试！");
            });
      }else{
        this.$message.error("未选中数据，无法操作！");
      }

    },
    getData() {
      this.loading = true;
      unhandledTicket(
        this.pager.currentPage,
        this.pager.pageSize,
        this.formInline
      )
        .then(({ content, page, size, totalCount }) => {
          this.userData = content.map((item) => {
            if (item.obverseURL) {
              item.obverseURL = `https://www.chichengkucun.com/images/${item.obverseURL}`;
            }

            if (item.reverseURL) {
              item.reverseURL = `https://www.chichengkucun.com/images/${item.reverseURL}`;
            }

            item.isOutLine = 1;

            return item;
          });

          this.pager.currentPage = page;
          this.pager.pageSize = size;
          this.pager.total = totalCount;
          this.editForm = {};
        })
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handlePager(pager) {
      this.pager.currentPage = pager.currentPage;
      this.pager.pageSize = pager.pageSize;
      this.getData();
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.formInline = {};
      this.getData();
    },
    handleBatchEditFormConfirm(data) {
      // for (let index=0; index < this.selectRows.length; index++) {
      //   const elem = this.selectRows[index];
      //   let account = elem.account
      //   if(!account){
      //     this.$message.warning("未选择所在户，无法操作！");
      //     return;
      //   }
      // }

      if (this.selectRows.length) {
        updateBatchCaptureTicket(
          this.selectRows.map((item) => {
            item.inSalesman = data.inSalesman;
            item.inSalesmanId = data.inSalesmanId;
            item.account = data.account;
            item.isOutLine = data.isOutLine;
            item.cusType = data.cusType;
            return item;
          })
        ).then((data) => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getData();
        });
      } else {
        this.$message.warning("未选中数据，无法操作！");
      }
    },
    handleSelect(selection, row) {
      this.selectRows = selection;
    },
  },
};
</script>

<style scoped>
.searchBar {
  margin-top: 20px;
  height: 50px;
}
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
/* >>>.el-form-item__content {
  line-height: 32px;
    display: flex;
} */
</style>



// WEBPACK FOOTER //
// src/views/ticket/ticket-capture/index.vue